export default "/images/vendor/@coreui/icons/svg/flag/cif-be.svg?5c41e295ac949d7c3d3cb008e5098bc7";